import { z } from 'zod';

export const itemCollectionFormSchema = z.object({
  name: z.string().min(1, 'Collection name is required'),
  slug: z.string()
    .min(1, 'Slug is required')
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Slug must be lowercase with hyphens only'),
  description: z.string().optional().nullable(),
  is_active: z.boolean().default(true),
  items: z.array(z.object({
    id: z.number(),
    item_id: z.number(),
    name: z.string(),
    code: z.string().optional().nullable(),
    sort_order: z.number().default(0),
  })).default([]),
});

export type ItemCollectionFormValues = z.infer<typeof itemCollectionFormSchema>;